import React from "react";

const AhbabProgressBar = ({ progress = 0, height = 5, color = "#28a745" }) => {
  const containerStyle = {
    width: "100%",
    backgroundColor: "#e0e0e0",
    borderRadius: "8px",
    overflow: "hidden",
    height: `${height}px`,
  };

  const fillerStyle = {
    height: "100%",
    width: `${progress}%`,
    backgroundColor: color,
    transition: "width 0.4s ease-in-out",
  };

  return (
    <div style={containerStyle}>
      <div style={fillerStyle}></div>
    </div>
  );
};

export default AhbabProgressBar;
